import React, { StrictMode, Suspense } from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import MouseParticles from "react-mouse-particles";

import "./i18n";
import App from "./App";
import "./index.css";

const root = document.getElementById("root");

render(
  <Suspense fallback={<div>Loading...</div>}>
    <StrictMode>
      <BrowserRouter>
        <App />
        <MouseParticles g={1} color="random" cull="col,image-wrapper" life={1} />
      </BrowserRouter>
    </StrictMode>
  </Suspense>,
  root
);
